/** * Tooltip.vue **/
<template>
  <div ref="containerRef" class="tooltip-container">
    <slot name="tooltip">
      <TooltipComponent
        v-if="visible"
        :bbox="bbox"
        :margin="margin"
        :text="text"
        :position="position"
        :multiline="multiline"
        :multiline-small="multilineSmall"
        :multiline-manual="multilineManual"
      />
    </slot>

    <slot />
  </div>
</template>
<script setup lang="ts">
import { ref, watch, onMounted, onBeforeUnmount } from 'vue'

defineOptions({ name: 'CartoComponentTooltip' })

const props = withDefaults(
  defineProps<{
    text?: string | number | boolean
    position?: string
    margin?: number
    multiline?: boolean
    multilineSmall?: boolean
    multilineManual?: boolean
  }>(),
  {
    text: '',
    position: 'top',
    margin: 0,
    multiline: false,
    multilineSmall: false,
    multilineManual: false,
  },
)

const visible = ref(false)
const bbox = ref<DOMRect | null>(null)
const textValue = ref(props.text)

// A template ref, not $el: in dev a root-level template comment turns the
// root into a fragment whose $el is an empty text node that gets no events
const containerRef = ref<HTMLElement | null>(null)

watch(
  () => props.text,
  (value) => {
    textValue.value = value
  },
)

onMounted(() => {
  const el = containerRef.value
  if (textValue.value && el) {
    el.addEventListener('mouseover', show, false)
    el.addEventListener('mouseout', hide, false)
  }
})

onBeforeUnmount(() => {
  const el = containerRef.value
  if (el) {
    el.removeEventListener('mouseover', show)
    el.removeEventListener('mouseout', hide)
  }
  window.removeEventListener('scroll', hide)
})

function show(): void {
  const el = containerRef.value
  if (!el) return
  bbox.value = el.getBoundingClientRect()
  visible.value = true
  window.addEventListener('scroll', hide, false)
}

function hide(): void {
  bbox.value = null
  visible.value = false
  window.removeEventListener('scroll', hide)
}
</script>
<style scoped lang="scss" src="./tooltip.scss"></style>
